import { ITableColumns } from "../types"

export function getColumnKey<T>(column: ITableColumns<T>, index: number): string {
    return (column?.key as string) || (column as any)?.dataIndex || index.toString()
}
